export const contactInfo = `
<html>

<head>
    <meta content="text/html; charset=UTF-8" http-equiv="content-type">
    <style type="text/css">
        ol {
            margin: 0;
            padding: 0
        }
        
        table td,
        table th {
            padding: 0
        }
        
        .c0 {
            color: #000000;
            font-weight: 400;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 14pt;
            font-family: "Times New Roman";
            font-style: normal
        }
        
        .c1 {
            padding-top: 0pt;
            padding-bottom: 0pt;
            line-height: 1.5;
            orphans: 2;
            widows: 2;
            text-align: left
        }
        
        .c2 {
            font-size: 14pt;
            font-family: "Times New Roman";
            font-weight: 700
        }
        
        .c3 {
            background-color: #ffffff;
            max-width: 451.4pt;
            padding: 72pt 72pt 72pt 72pt
        }
        
        .title {
            padding-top: 0pt;
            color: #000000;
            font-size: 26pt;
            padding-bottom: 3pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }
        
        .subtitle {
            padding-top: 0pt;
            color: #666666;
            font-size: 15pt;
            padding-bottom: 16pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }
        
        li {
            color: #000000;
            font-size: 11pt;
            font-family: "Arial"
        }
        
        p {
            margin: 0;
            color: #000000;
            font-size: 11pt;
            font-family: "Arial"
        }
        
        h1 {
            padding-top: 20pt;
            color: #000000;
            font-size: 20pt;
            padding-bottom: 6pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }
        
        h2 {
            padding-top: 18pt;
            color: #000000;
            font-size: 16pt;
            padding-bottom: 6pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }
        
        h3 {
            padding-top: 16pt;
            color: #434343;
            font-size: 14pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }
        
        h4 {
            padding-top: 14pt;
            color: #666666;
            font-size: 12pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }
        
        h5 {
            padding-top: 12pt;
            color: #666666;
            font-size: 11pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }
        
        h6 {
            padding-top: 12pt;
            color: #666666;
            font-size: 11pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            font-style: italic;
            orphans: 2;
            widows: 2;
            text-align: left
        }
    </style>
</head>

<body class="c3">
    <p class="c1"><span class="c2">&#1048;&#1085;&#1076;&#1080;&#1074;&#1080;&#1076;&#1091;&#1072;&#1083;&#1100;&#1085;&#1099;&#1081; &#1087;&#1088;&#1077;&#1076;&#1087;&#1088;&#1080;&#1085;&#1080;&#1084;&#1072;&#1090;&#1077;&#1083;&#1100; &#1041;&#1088;&#1072;&#1094;&#1091;&#1085; &#1040;&#1085;&#1085;&#1072; &#1057;&#1077;&#1088;&#1075;&#1077;&#1077;&#1074;&#1085;&#1072; </span>
        <span
            class="c0"><br>344011 &#1075;&#1086;&#1088;. &#1056;&#1086;&#1089;&#1090;&#1086;&#1074;-&#1085;&#1072;-&#1044;&#1086;&#1085;&#1091;, &#1091;&#1083;. &#1050;&#1072;&#1090;&#1072;&#1077;&#1074;&#1072;, &#1076;. 259 &#1082;&#1074;. 3 <br>&#1048;&#1053;&#1053;
            616608081864 </span>
    </p>
    <p class="c1"><span class="c0">&#1054;&#1043;&#1056;&#1053;&#1048;&#1055; 320619600119490 <br>&#1057;&#1095;&#1105;&#1090; &#8470;: 40802810009500022941 <br>&#1058;&#1054;&#1063;&#1050;&#1040; &#1055;&#1040;&#1054; &#1041;&#1040;&#1053;&#1050;&#1040; &laquo;&#1060;&#1050; &#1054;&#1058;&#1050;&#1056;&#1067;&#1058;&#1048;&#1045;&raquo; <br>&#1041;&#1048;&#1050; 044525999</span></p>
    <p
        class="c1"><span class="c0">&#1082;/&#1089;&#1095; 30101810845250000999</span></p>
</body>

</html>
`;
